// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 1.0
// updated  : 2026-06-20
// protected: NO  -> D-028 Pre-UAT Polish: brand assets (ETAMS/Arema/Borneo) + fallback.
// =============================================================================
// Aset brand dipakai dari frontend/public/brand/. Semua punya fallback teks bila gagal load.
import React, { useState } from "react";

const ETAMS_SRC = { black: "/brand/etams-black.png", white: "/brand/etams-white.png" };
const ETAMS_MARK_SRC = { black: "/brand/etams-mark-black.png", white: "/brand/etams-mark-white.png" };
const CLUB_SRC = { arema: "/brand/arema.png", borneo: "/brand/borneo.png" };

// Logo ETAMS (brand utama). Fallback -> teks "ETAMS".
// variant="auto": render DUA <img> sekaligus; pilihan diserahkan ke CSS berbasis <html class="dark">
// (hitam saat terang, putih saat gelap). NOL JavaScript -> tak ada state basi saat toggle tema.
export const BrandLogo = ({ variant = "black", className = "h-8 w-auto", alt = "ETAMS" }) => {
  const [err, setErr] = useState(false);
  if (err) return <span className="font-bold tracking-tight text-foreground">ETAMS</span>;
  if (variant === "auto") {
    return (
      <>
        <img src={ETAMS_SRC.black} onError={() => setErr(true)}
             className={`${className} block dark:hidden`} alt={alt} data-testid="brand-etams-logo" />
        <img src={ETAMS_SRC.white} onError={() => setErr(true)}
             className={`${className} hidden dark:block`} alt={alt} aria-hidden="true" />
      </>
    );
  }
  return <img src={ETAMS_SRC[variant] || ETAMS_SRC.black} onError={() => setErr(true)}
              className={className} alt={alt} data-testid="brand-etams-logo" />;
};

// Mark ETAMS (flame saja, TANPA tulisan "ETAMS") — untuk card login Google.
export const BrandMark = ({ variant = "white", className = "h-14 w-auto", alt = "ETAMS" }) => {
  const [err, setErr] = useState(false);
  if (err) return <BrandLogo variant={variant} className={className} alt={alt} />;
  return <img src={ETAMS_MARK_SRC[variant] || ETAMS_MARK_SRC.white} onError={() => setErr(true)}
              className={className} alt={alt} data-testid="brand-etams-mark" />;
};

// Tentukan klub dari role/region efektif (Arema=SBY/Arema, Borneo=SMD/Borneo). Owner GLOBAL -> null.
export const clubFor = (role, region) => {
  const r = (role || "").toUpperCase();
  if (r.includes("AREMA") || region === "SBY") return { key: "arema", label: "Arema FC" };
  if (r.includes("BORNEO") || region === "SMD") return { key: "borneo", label: "Borneo FC" };
  return null;
};

// Badge klub (logo + label) dengan fallback teks. size: 'sm' | 'md'.
export const ClubBadge = ({ role, region, size = "sm", showLabel = true }) => {
  const [err, setErr] = useState(false);
  const club = clubFor(role, region);
  if (!club) return null;
  const dim = size === "md" ? "h-7 w-7" : "h-5 w-5";
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`club-badge-${club.key}`}>
      {err
        ? <span className="text-[11px] font-semibold text-muted-foreground">{club.label}</span>
        : <img src={CLUB_SRC[club.key]} onError={() => setErr(true)}
               className={`${dim} object-contain rounded-sm`} alt={club.label} />}
      {showLabel && !err && <span className="text-[11px] font-medium text-muted-foreground hidden lg:inline">{club.label}</span>}
    </span>
  );
};
